import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, SmartphoneIcon, LockIcon } from 'lucide-react';
interface OTPScreenProps {
  onBack: () => void;
  onVerify: () => void;
}
export function OTPScreen({
  onBack,
  onVerify
}: OTPScreenProps) {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const handleChange = (index: number, value: string) => {
    if (value.length > 1) value = value[0];
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    // Move to next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const isComplete = otp.every(digit => digit !== '');
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="w-full min-h-screen flex flex-col py-6 px-6" style={{
    backgroundColor: '#FFF5F0'
  }} data-id="element-497">
      {/* Header */}
      <div className="flex items-center justify-between mb-8" data-id="element-498">
        <button onClick={onBack} className="p-2 -ml-2 rounded-full hover:bg-black/5 transition-colors" data-id="element-499">
          <ArrowLeftIcon className="w-6 h-6 text-[#1A1A1A]" strokeWidth={2} data-id="element-500" />
        </button>
        <img src="https://cdn.magicpatterns.com/uploads/k5mzauqmFki77bNt7CFYh1/Whatsapp_digiBOP-removebg-preview.png" alt="digiBOP Logo" className="h-8 w-auto" data-id="element-501" />
        <div className="w-10" data-id="element-502" />
      </div>

      {/* Title */}
      <div className="mb-12" data-id="element-503">
        <div className="w-12 h-12 rounded-full bg-[#FCECE3] flex items-center justify-center mb-4" data-id="element-504">
          <SmartphoneIcon className="w-6 h-6 text-[#D95A1A]" strokeWidth={2} data-id="element-505" />
        </div>
        <div className="flex items-center gap-2 mb-2" data-id="element-506">
          <h1 className="text-[32px] font-bold text-[#1A1A1A] leading-tight tracking-tight" data-id="element-507">
            Enter OTP
          </h1>
          <div className="flex items-center gap-1 bg-[#22C55E]/10 text-[#22C55E] px-2 py-1 rounded-full" data-id="element-508">
            <LockIcon className="w-3 h-3" strokeWidth={2.5} data-id="element-509" />
            <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-510">
              Encrypted
            </span>
          </div>
        </div>
        <p className="text-[15px] text-[#8A7B72] leading-relaxed" data-id="element-511">
          We've sent a 6-digit verification code to your registered mobile
          number ending in{' '}
          <span className="font-bold text-[#1A1A1A]" data-id="element-512">**67</span>
        </p>
      </div>

      {/* OTP Inputs */}
      <div className="flex justify-between gap-2 mb-8" data-id="element-513">
        {otp.map((digit, index) => <input key={index} ref={el => inputRefs.current[index] = el} type="password" inputMode="numeric" value={digit} onChange={e => handleChange(index, e.target.value)} onKeyDown={e => handleKeyDown(index, e)} className="w-12 h-14 bg-white border-2 border-transparent focus:border-[#D95A1A] rounded-xl text-center text-[24px] font-bold text-[#1A1A1A] outline-none shadow-sm transition-all" maxLength={1} data-id="element-514" />)}
      </div>

      <div className="text-center mb-auto" data-id="element-515">
        <p className="text-[14px] text-[#8A7B72]" data-id="element-516">
          Didn't receive the code?{' '}
          <button className="font-bold text-[#D95A1A] hover:underline" data-id="element-517">
            Resend
          </button>
        </p>
      </div>

      {/* Bottom Section */}
      <div className="pb-4 pt-8" data-id="element-518">
        <button onClick={onVerify} disabled={!isComplete} className="w-full bg-gradient-to-r from-[#D95A1A] to-[#B84A12] text-white py-4 rounded-full font-bold text-[15px] tracking-wide shadow-[0_8px_20px_rgba(217,90,26,0.3)] hover:shadow-[0_8px_25px_rgba(217,90,26,0.4)] active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-519">
          VERIFY
        </button>
      </div>
    </motion.div>;
}